import { useRef } from 'react'
import type { VariableTextEditorProps } from '@super/node-graph-ui'
import { VariableAutocompleteTextarea } from '@/features/agent-detail/VariableAutocompleteTextarea'
import { cn } from '@/lib/utils'

/**
 * Bridges the node-graph-ui `VariableTextEditor` injection point to the
 * admin's VariableAutocompleteTextarea so every node-level and form-item
 * text field shares one `{{` variable picker. The caller passes a className
 * that owns the border/padding/sizing; this adapter only wires focus state,
 * variables, and the compact popover-row density that matches text-xs.
 */
export function AdminVariableTextEditor({
  value,
  onValueChange,
  onKeyDown,
  onPaste,
  onFocus,
  onBlur,
  placeholder,
  className,
  rows = 1,
  id,
  name,
  dataFormItemId,
  textareaRef,
  variables,
}: VariableTextEditorProps): React.JSX.Element {
  const internalRef = useRef<HTMLTextAreaElement | null>(null)
  return (
    <VariableAutocompleteTextarea
      ref={el => {
        internalRef.current = el
        textareaRef?.(el)
      }}
      id={id}
      name={name}
      data-form-item-id={dataFormItemId}
      rows={rows}
      value={value}
      onValueChange={onValueChange}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      variables={variables}
      compact
      className={cn('text-xs leading-relaxed', className)}
    />
  )
}
